import { Band, BandStatus } from "./types";

// TODO(SD-837): scoreMetric uses linear interpolation between five fixed
// percentile anchors (p10/p25/p50/p75/p90). This is a pragmatic v1 — it does
// not match the shape of a normal distribution, and percentiles outside the
// anchors clamp at 10 / 90. Once we have real normative data, consider:
//   - z-score-based scoring with mean/SD per metric
//   - non-linear interpolation between anchor percentiles
//   - separate scoring functions per metric type if appropriate
export function scoreMetric(value: number | null | undefined, band: Band): number | null {
  if (value === null || value === undefined || Number.isNaN(value)) return null;

  const valueAnchors =
    band.direction === "higherIsBetter"
      ? [band.p10, band.p25, band.p50, band.p75, band.p90]
      : [band.p90, band.p75, band.p50, band.p25, band.p10];

  const percentileAnchors =
    band.direction === "higherIsBetter" ? [10, 25, 50, 75, 90] : [90, 75, 50, 25, 10];

  if (value <= valueAnchors[0]) return percentileAnchors[0];
  if (value >= valueAnchors[valueAnchors.length - 1]) {
    return percentileAnchors[percentileAnchors.length - 1];
  }

  for (let i = 0; i < valueAnchors.length - 1; i += 1) {
    const lo = valueAnchors[i];
    const hi = valueAnchors[i + 1];
    if (value >= lo && value <= hi) {
      const span = hi - lo;
      if (span === 0) return percentileAnchors[i];
      const fraction = (value - lo) / span;
      const pLo = percentileAnchors[i];
      const pHi = percentileAnchors[i + 1];
      return pLo + fraction * (pHi - pLo);
    }
  }

  return null;
}

export function bandStatusForScore(score: number | null): BandStatus | null {
  if (score === null) return null;
  if (score >= 75) return "excellent";
  if (score >= 25) return "typical";
  return "needsAttention";
}
